const NAMESPACE = "programchannels";

const KEYS = {
    singleInstanceGroupLabel: "singleInstanceGroupLabel",
    publishNewChannelButtonLabel: "publishNewChannelButtonLabel",
    emptyPublishedChannelListMessage: "emptyPublishedChannelListMessage",
    emptyLinkedChannelListMessage: "emptyLinkedChannelListMessage",
    noGroups: "noGroups",
    noPrograms: "noPrograms",
    noFields: "noFields",
    noFieldsButAddable: "noFieldsButAddable",
    configureButtonLabel: "configureButtonLabel",
    publishingStatusButtonLabel: "publishingStatusButtonLabel",
    workflowStatusesButtonLabel: "workflowStatusesButtonLabel",
    deleteChannelButtonLabel: "deleteChannelButtonLabel",
    exportChannelButtonLabel: "exportChannelButtonLabel",
    publishedChannelsTabTitle: "publishedChannelsTabTitle",
    linkedChannelsTabTitle: "linkedChannelsTabTitle",
    connectionsUsingMessage: "connectionsUsingMessage",
    linkToChannelButtonLabel: "linkToChannelButtonLabel",
    unlinkFromChannelButtonLabel: "unlinkFromChannelButtonLabel",
    linkToChannelText: "linkToChannelText",
    availableChannelsText: "availableChannelsText",
    noAvailableChannelsText: "noAvailableChannelsText",
    disableButtonLabel: "disableButtonLabel",
    enableButtonLabel: "enableButtonLabel",
    deleteButtonLabel: "deleteButtonLabel",
    cancelButtonLabel: "cancelButtonLabel",
    saveButtonLabel: "saveButtonLabel",
    linkButtonLabel: "linkButtonLabel",
    publishChannelDialogTitle: "publishChannelDialogTitle",
    workflowStatusesDialogTitle: "workflowStatusesDialogTitle",
    linkToChannelDialogTitle: "linkToChannelDialogTitle",
    groupToLinkToSelectionLabel: "groupToLinkToSelectionLabel",
    channelSelectorLabel: "channelSelectorLabel",
    noChannelsAvailableError: "noChannelsAvailableError",
    channelUsesConnectionsError: "channelUsesConnectionsError",
    channelNameListColumn: "channelNameListColumn",
    programsUsingChannelListColumn: "programsUsingChannelListColumn",
    publishedToGroupsListColumn: "publishedToGroupsListColumn",
    channelTypeListColumn: "channelTypeListColumn",
    publishedByProgramListColumn: "publishedByProgramListColumn",
    statusListColumn: "statusListColumn",
    okButtonLabel: "okButtonLabel",
    confirmRemoveLinkDialogTitle: "confirmRemoveLinkDialogTitle",
    confirmRemoveLinkDialogText: "confirmRemoveLinkDialogText",
    confirmDeleteChannelDialogTitle: "confirmDeleteChannelDialogTitle",
    confirmDeleteChannelDialogText: "confirmDeleteChannelDialogText",
    confirmExportChannelDialogTitle: "confirmExportChannelDialogTitle",
    confirmExportChannelDialogText: "confirmExportChannelDialogText",
    nothingToConfigureText: "nothingToConfigureText",
    fieldTypeSelectorLabel: "fieldTypeSelectorLabel",
    noneSelectedOptionLabel: "noneSelectedOptionLabel",
    channelNameInputLabel: "channelNameInputLabel",
    channelCreateFromLabel: "channelCreateFromLabel",
    channelCreateFromNewText: "channelCreateFromNewText",
    channelCreateEditableText: "channelCreateEditableText",
    channelCreateFromUploadText: "channelCreateFromUploadText",
    channelUploadDefinitionLabel: "channelUploadDefinitionLabel",
    channelUploadingText: "channelUploadingText",
    channelTypeSelectorLabel: "channelTypeSelectorLabel",
    nothingToConfigureForLink: "nothingToConfigureForLink",
    backToChannelsPageButtonLabel: "backToChannelsPageButtonLabel",
    propertiesButtonLabel: "propertiesButtonLabel",
    channelPropertiesDialogTitle: "channelPropertiesDialogTitle",
    showOnLandingPageCheckboxLabel: "showOnLandingPageCheckboxLabel",
    projectLandingPageButtonLabelLabel: "projectLandingPageButtonLabelLabel",
    labelRequiredMessage: "labelRequiredMessage",
    notInAnyChannelsGroupMessage: "notInAnyChannelsGroupMessage",
    notInAnyChannelsGroupTitle: "notInAnyChannelsGroupTitle",
    enabledStatusLabel: "enabledStatusLabel",
    disabledStatusLabel: "disabledStatusLabel",
    channelNameDraftText: "channelNameDraftText",
    saveDraftButtonLabel: "saveDraftButtonLabel",
    duplicateNameMessage: "duplicateNameMessage",
    dataSlotName: "dataSlotName",
    attachmentSlotName: "attachmentSlotName",
    roleSlotName: "roleSlotName",
    formSlotName: "formSlotName",
    statusSlotName: "statusSlotName",
    signalSlotName: "signalSlotName",
    memberSpecificSlotLabel: "memberSpecificSlotLabel",
    memberSlotAliasLabel: "memberSlotAliasLabel",
    addSlotButtonLabel: "addSlotButtonLabel"
};

const MESSAGES = {
    [KEYS.singleInstanceGroupLabel]: {
        value: "Configuration",
        comment: "Label for single-instance groups in the channel configuration"
    },
    [KEYS.publishNewChannelButtonLabel]: {
        value: "Publish New Channel",
        comment: "button to create a new published channel"
    },
    [KEYS.emptyPublishedChannelListMessage]: {
        value: "This program is not publishing any channels.",
        comment: "shown when the published channels list is empty"
    },
    [KEYS.noGroups]: {
        value: "None",
        comment: "shown when there are no groups in list"
    },
    [KEYS.noPrograms]: {
        value: "None",
        comment: "shown when there are no programs in list"
    },
    [KEYS.configureButtonLabel]: {
        value: "Configure",
        comment: ""
    },
    [KEYS.publishingStatusButtonLabel]: {
        value: "Publish Channel",
        comment: "button label"
    },
    [KEYS.workflowStatusesButtonLabel]: {
        value: "Workflow Statuses",
        comment: "button label"
    },
    [KEYS.deleteChannelButtonLabel]: {
        value: "Delete Channel",
        comment: "button label"
    },
    [KEYS.exportChannelButtonLabel]: {
        value: "Export Channel",
        comment: "export channel button label"
    },
    [KEYS.linkButtonLabel]: {
        value: "Link",
        comment: "button label"
    },
    [KEYS.publishedChannelsTabTitle]: {
        value: "Published Channels",
        comment: "tab title"
    },
    [KEYS.linkedChannelsTabTitle]: {
        value: "Linked Channels",
        comment: "tab title"
    },
    [KEYS.connectionsUsingMessage]: {
        value: "Connections using this channel:",
        comment: "Message for internal linked channels that cannot be edited from this page"
    },
    [KEYS.linkToChannelButtonLabel]: {
        value: "Link to Channel",
        comment: "button label"
    },
    [KEYS.unlinkFromChannelButtonLabel]: {
        value: "Unlink From Channel",
        comment: "button label"
    },
    [KEYS.emptyLinkedChannelListMessage]: {
        value: "This program is not linked to any channels.",
        comment: "shown when the linked channels list is empty"
    },
    [KEYS.linkToChannelText]: {
        value: "Link Pending",
        comment: "Message that appears for a consuming connection that hasn't been linked"
    },
    [KEYS.availableChannelsText]: {
        value: "Available Channels",
        comment: "Header for the available channels list"
    },
    [KEYS.noAvailableChannelsText]: {
        value: "No available channels",
        comment: "Text that appears when there are no available channels"
    },
    [KEYS.disableButtonLabel]: {
        value: "Disable",
        comment: "button label"
    },
    [KEYS.enableButtonLabel]: {
        value: "Enable",
        comment: "button label"
    },
    [KEYS.deleteButtonLabel]: {
        value: "Delete",
        comment: "button label"
    },
    [KEYS.publishChannelDialogTitle]: {
        value: "Publish Channel to Groups",
        comment: "dialog title"
    },
    [KEYS.workflowStatusesDialogTitle]: {
        value: "Configure Workflow Statuses",
        comment: "dialog title"
    },
    [KEYS.cancelButtonLabel]: {
        value: "Cancel",
        comment: "button label"
    },
    [KEYS.saveButtonLabel]: {
        value: "Save",
        comment: "button label"
    },
    [KEYS.linkToChannelDialogTitle]: {
        value: "Link to Channel",
        comment: "dialog title"
    },
    [KEYS.groupToLinkToSelectionLabel]: {
        value: "Group to link to",
        comment: "dropdown label"
    },
    [KEYS.channelSelectorLabel]: {
        value: "Channel",
        comment: "dropdown label"
    },
    [KEYS.noChannelsAvailableError]: {
        value: "No channels are available in this group",
        comment: "Error message when selecting a group that has no published channels"
    },
    [KEYS.channelUsesConnectionsError]: {
        value: "Must be configured via the Connections page",
        comment: "Error message when trying to link to a channel that requires connections to configure"
    },
    [KEYS.channelNameListColumn]: {
        value: "Channel Name",
        comment: "List Column header"
    },
    [KEYS.programsUsingChannelListColumn]: {
        value: "Programs using Channel",
        comment: "List Column header"
    },
    [KEYS.publishedToGroupsListColumn]: {
        value: "Published to Groups",
        comment: "List Column header"
    },
    [KEYS.channelTypeListColumn]: {
        value: "Channel Type",
        comment: "List Column header"
    },
    [KEYS.publishedByProgramListColumn]: {
        value: "Published By",
        comment: "List Column header"
    },
    [KEYS.statusListColumn]: {
        value: "Status",
        comment: "List Column header"
    },
    [KEYS.okButtonLabel]: {
        value: "OK",
        comment: "button label"
    },
    [KEYS.confirmRemoveLinkDialogTitle]: {
        value: "Confirm removal",
        comment: "dialog title"
    },
    [KEYS.confirmRemoveLinkDialogText]: {
        value: "Are you sure you want to delete the link to this channel?",
        comment: "dialog text"
    },
    [KEYS.confirmDeleteChannelDialogTitle]: {
        value: "Confirm deletion",
        comment: "dialog title"
    },
    [KEYS.confirmDeleteChannelDialogText]: {
        value: "Are you sure you want to delete this channel?",
        comment: "dialog text"
    },
    [KEYS.confirmExportChannelDialogTitle]: {
        value: "Confirm Export",
        comment: "dialog title"
    },
    [KEYS.confirmExportChannelDialogText]: {
        value: "Are you sure you want to export this channel? The channel definition cannot be edited after exporting.",
        comment: "dialog text"
    },
    [KEYS.nothingToConfigureText]: {
        value: "Nothing configurable",
        comment: "displayed when a slot has nothing to configure"
    },
    [KEYS.fieldTypeSelectorLabel]: {
        value: "Type",
        comment: "label for the field type selector"
    },
    [KEYS.noneSelectedOptionLabel]: {
        value: " --- None ---",
        comment: "dropdown option if nothing is selected in dropdown"
    },
    [KEYS.noFields]: {
        value: "None",
        comment: "text when no fields are in a group"
    },
    [KEYS.noFieldsButAddable]: {
        value: 'None - click "Add" to set up.',
        comment: "dropdown option if nothing is selected in dropdown"
    },
    [KEYS.channelNameInputLabel]: {
        value: "Channel Name",
        comment: "input label for channel name"
    },
    [KEYS.channelCreateFromLabel]: {
        value: "Create From",
        comment: "input label for create from selector (new or upload)"
    },
    [KEYS.channelCreateFromNewText]: {
        value: "New Channel",
        comment: "selector text for create from new"
    },
    [KEYS.channelCreateEditableText]: {
        value: "Upload Definition And Edit",
        comment: "selector text for create and edit from file"
    },
    [KEYS.channelCreateFromUploadText]: {
        value: "Upload Definition File",
        comment: "selector text for create from uploaded file"
    },
    [KEYS.channelUploadDefinitionLabel]: {
        value: "Upload Definition File",
        comment: "upload definition file input label"
    },
    [KEYS.channelUploadingText]: {
        value: "Importing Channel From Definition File...",
        comment: "text displayed when importing a channel from a definition file"
    },
    [KEYS.channelTypeSelectorLabel]: {
        value: "Channel Type",
        comment: "label for the channel type dropdown"
    },
    [KEYS.nothingToConfigureForLink]: {
        value: "Nothing to configure for this channel on this side",
        comment: "text if there is nothing to configure"
    },
    [KEYS.backToChannelsPageButtonLabel]: {
        value: "Back to Channels page",
        comment: "button label"
    },
    [KEYS.propertiesButtonLabel]: {
        value: "Properties",
        comment: "button label"
    },
    [KEYS.channelPropertiesDialogTitle]: {
        value: "Channel Properties",
        comment: "dialog title"
    },
    [KEYS.showOnLandingPageCheckboxLabel]: {
        value: "Show on Project Landing Page",
        comment: "checkbox label"
    },
    [KEYS.projectLandingPageButtonLabelLabel]: {
        value: "Label for button on Project Landing Page",
        comment: "label for the text box receiving the label of a button to display"
    },
    [KEYS.labelRequiredMessage]: {
        value: "Button label is required to display the button on the landing page.",
        comment:
            "label for the text box receiving the label of a button to display being empty if showing a button on the landing page is selected"
    },
    [KEYS.notInAnyChannelsGroupTitle]: {
        value: "No Channel Group Available",
        comment: "error message title when trying to publish a channel but there aren't any groups"
    },
    [KEYS.notInAnyChannelsGroupMessage]: {
        value: "This program is not part of any Channel Group. Contact support{'@'}powerclerk.com to set one up.",
        comment: "error message when trying to publish a channel but there aren't any groups"
    },
    [KEYS.enabledStatusLabel]: {
        value: "Enabled",
        comment: "Label for the Status column of the Linked Channels table"
    },
    [KEYS.disabledStatusLabel]: {
        value: "Disabled",
        comment: "Label for the Status column of the Linked Channels table"
    },
    [KEYS.channelNameDraftText]: {
        value: "(DRAFT)",
        comment: "Text that appears after a channel that is still a draft"
    },
    [KEYS.saveDraftButtonLabel]: {
        value: "Save Editable Draft",
        comment: "Text that apprears for the Save Draft button"
    },
    [KEYS.duplicateNameMessage]: {
        value: "This field has a duplicate name.",
        comment: "Text that appears when validating duplicate names"
    },
    [KEYS.dataSlotName]: {
        value: "Data Field",
        comment: "Name for data slot types"
    },
    [KEYS.attachmentSlotName]: {
        value: "Attachment",
        comment: "Name for attachment slot types"
    },
    [KEYS.roleSlotName]: {
        value: "Role",
        comment: "Name for role slot types"
    },
    [KEYS.formSlotName]: {
        value: "Form",
        comment: "Name for form slot types"
    },
    [KEYS.statusSlotName]: {
        value: "Workflow Status",
        comment: "Name for status slot types"
    },
    [KEYS.signalSlotName]: {
        value: "Signal",
        comment: "Name for signal slot types"
    },
    [KEYS.memberSpecificSlotLabel]: {
        value: "Specific {slotType}",
        comment: "Label for the slot's target field/attachment"
    },
    [KEYS.memberSlotAliasLabel]: {
        value: "{slotType} Alias",
        comment: "Label for the slot alias (field/attachment)"
    },
    [KEYS.addSlotButtonLabel]: {
        value: "Add {slotType}",
        comment: "Label for that button that adds another slot (field/attachment)"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
